<template>
    <div v-if="bizAuth.createTask.hasRight" class="page-setting has-bc biz-new-task parent-frame" :class="{'fixed': listIsFixed}">
        <div class="tool-bar-mask"></div>
        <div class="page-header">
            <h1>{{$route.meta.title}}</h1>
            <div class="btn-group">
                <button class="default-button publish" @click="submitEnt += 1" :disabled="disabledState">儲存</button>
            </div>
        </div>
        <new-task-comp :submit="submitEnt" @disabledState="setDisabledState"></new-task-comp>
    </div>
</template>
<script>
import NewTaskComp from '@/components/bussiness/mgtCategory/taskMgt/newTask/NewTaskComp.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return{
            listIsFixed: false,
            submitEnt: 0,
            disabledState: false,
        }
    },
    watch: {
        'bizAuth.createTask.hasRight': function (val) {
            if(!val){
                this.$store.dispatch('setModalStatus', {state: true, type: 'bizNoRight'})
            }
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
    },
    methods: {
        handleScroll: function () {
            if(!this.isModalMode){
                let scrollTop = event.target.documentElement.scrollTop
                if( scrollTop >= 50){
                    document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'none'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                }else{
                    document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                    this.listIsFixed = false
                }

                if( scrollTop >= 115){
                    this.listIsFixed = true
                }
            }
        },
        setDisabledState: function (val){
            this.disabledState = val
        }
    },
    computed: {
        ...mapGetters({
            bizAuth: 'GET_BIZ_AUTH',
            isModalMode: 'GET_MODAL_MODE',
        })
    },
    components: {
        NewTaskComp
    }
}
</script>
<style lang="scss">
 
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/mgtCategory/taskMgt/newTask.vue